import React, { Component } from 'react'
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import RequestManager from "../../singletons/RequestManager";
import AddDeliverySlotDetails from './AddDeliverySlotDetails';

export default class Deliveryslots extends Component {

  constructor(props) {
    super(props);
    this.state = {
      deliverydetail: null,
      refreshdeliverydetail:false,
      storeInformation:null
    };
  }


  componentDidMount() {
    this.state.storeInformation = JSON.parse(localStorage.getItem("storeInformation"))
    if (this.state.storeInformation.store.id != undefined){
      console.log("before storedeliveryslot", this.state.storeInformation.store.id)
    this.storeDeliverySlot();
    }
  }

  deriveDeliveryType = (n_type) =>{
    if (n_type == 'ONDEMAND') {
      return 'ON-DEMAND';
    }else{
      return 'SCHEDULED';
    }
  }

  durationTranslate = (n_duration) =>{
    console.log('n_duation',n_duration)
    switch(n_duration) {
      case 30:
        return '30 Mins'
        break
      case 45:
        return '45 Mins'
        break
      case 60:
        return '1 Hour'
        break
      case 120:
        return '2 Hours'
        break
      case 180:
        return '3 Hours'
        break
      case 240:        
        return '4 Hours'
        break
    }

  }

  deleteslot = async (slotid) => {
    let requestManager = new RequestManager();
    let params;
    params ={
                input: {
                id: slotid,
                status: "INACTIVE"
                }
            }
    
    let response =await requestManager.getResponseFromPredefinedQuery(
      "DeleteStoreDeliverySlot",
      params
    );
    if (response.error === null) {
      console.log('from delivery slot', response);

    this.setState({
      refreshdeliverydetail:true
      
    });
    window.location.reload(false);
  }
}
  storeDeliverySlot = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    //let storeInformation = await JSON.parse(localStorage.getItem("storeInformation"));

    
    let params = {
      //input: {
        storeId: this.state.storeInformation.store.id,
    //}
    };
    console.log('from delivery slot-1', params);
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getstoreDeliverySlot",
      params
    );
    console.log('from delivery slot-2', params);  
    if (response.error === null) {
      console.log('response from delivery slot', response);

    this.setState({
      
      deliverydetail: response.data.getstoreDeliverySlot.edges,
     
    });
    // console.log(this.state.deliverydetail[0].node.id)
  }


  };



  render() {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    return (
      
      <div>
        <label style={{fontSize:20}}>DELIVERY SCHUEDULE</label>
        {/*striped bordered hover */}
      <Table responsive >
  <thead style={{background:'#0190F3',color:'white'}}>
    <tr>
     
      <th>Type </th>
      <th>Delivery Day</th>
      <th>Start Time</th>
      <th>End Time</th>
      <th>Duration (in mins) Ondemand only</th>
      <th>Capacity</th>
      <th>Order Cutoff</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
  {this.state.deliverydetail && this.state.deliverydetail.map(deliveryslotdetails => {
     return (
    <tr  key={deliveryslotdetails.node.id}>
      <td>{this.deriveDeliveryType(deliveryslotdetails.node.deliveryType)}</td> 
      <td>{deliveryslotdetails.node.deliveryType}</td>
      <td>{deliveryslotdetails.node.startTime}</td>
      <td>{deliveryslotdetails.node.endTime}</td>
      <td>{this.durationTranslate(deliveryslotdetails.node.deliveryduration)}</td>
      <td>{deliveryslotdetails.node.capacity}</td>
      <td>{deliveryslotdetails.node.orderCutoff}</td>
      <td><Button variant="danger" id={deliveryslotdetails.node.id} onClick={() => this.deleteslot(deliveryslotdetails.node.id)} >Delete</Button></td>
      
    </tr>
     )
     })} 
     <tr style={{width:'95%'}}> <AddDeliverySlotDetails/></tr>
  </tbody>
</Table>


      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DeliverySlots/DeliverySlots.js